import React from "react";
import Step1 from "../formComponents/form34/Step1";
import Step2 from "../formComponents/form34/Step2";
import Step3 from "../formComponents/form34/Step3";

const Form34 = () => {
  return (
    <div>
      <Step1 />;
      <Step2 />;
      <Step3 />;
    </div>
  );
};

export default Form34;
